import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { getTrans as t } from "../../Localization/translations";
import { API } from "../../backend";
import authHeader from "../../services/auth-header";
import Helper from "../../Helper";
import { useParams } from "react-router-dom";
import { useSubscriptionFeatures } from "../../contexts/SubscriptionContext";
export default function AddExpense() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [expense, setExpense] = useState({
    date: new Date(),
    amount: "",
    payto: "",
    reference: "",
    vendor: null,
    employee_name: "",
    category: "",
    description: "",
    attachment: null,
  });

  const { planFeatures } = useSubscriptionFeatures();
  const [vendorOptions, setVendorOptions] = useState([]);
  const [vendorIsLoading, setVendorIsLoading] = useState(false);
  const [vendorCurrentPage, setVendorCurrentPage] = useState(1);
  const [vendorInputValue, setVendorInputValue] = useState("");
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [categoryLoading, setCategoryLoading] = useState(false);
  const [allocationError, setAllocationError] = useState("");
  const [feeTypeOptions, setFeeTypeOptions] = useState([]);
  const [subcompanyOptions, setSubcompanyOptions] = useState([]);
  const [lineOfBusinessOptions, setLineOfBusinessOptions] = useState([]);

  const [subcompany, setSubcompany] = useState("");
  const [lineOfBusiness, setLineOfBusiness] = useState("");


  const handleExpenseDate = (value) => {
    setExpense({
      ...expense,
      date: value,
    });
  };


  const [allocations, setAllocations] = useState([
    { id: 1, contract: null, asset: null, customer: null, amount: "", feeType: "", assetOptions: [], customerOptions: [] }
  ]);


  const uploadAttachments = async (expenseId, files) => {
    for (let file of files) {
      const formData = new FormData();
      formData.append("file", file);

      await axios.post(
        API + `expenses/${expenseId}/attachments/`,
        formData,
        {
          headers: {
            ...authHeader(),
            "Content-Type": "multipart/form-data",
          },
        }
      );
    }
  };


        const isApprovalDisabled = planFeatures !== null && planFeatures.approvals === false;

  useEffect(() => {
    loadVendorOptions("", 1);
  }, []);

  const loadVendorOptions = async (searchValue, page) => {
    try {
      setVendorIsLoading(true);
      const query = searchValue ? `&customer_name=${searchValue}` : '';
      const url = `${API}parties/vendor/?party_type=Vendor${query}&page=${page}`;
      const response = await axios.get(url, { headers: authHeader() });
      const data = response.data.data || response.data;

      if (Array.isArray(data)) {
        if (page === 1) {
          setVendorOptions(data);
        } else {
          setVendorOptions(prev => [...prev, ...data]);
        }
        if (data.length > 0) setVendorCurrentPage(page + 1);
      }
      setVendorIsLoading(false);
    } catch (error) {
      console.error("Error fetching vendors:", error);
      setVendorIsLoading(false);
    }
  };

  const handleVendorInputChange = (newValue) => {
    setVendorInputValue(newValue);
    setVendorCurrentPage(1);
    loadVendorOptions(newValue, 1);
  };

  // useEffect(() => {
  //   axios.get(API + `expenses/${id}/`, { headers: authHeader() })
  //     .then(res => setExpense(res.data))
  //     .catch(err => console.error(err));
  // }, [id]);

  const handleVendorMenuScrollToBottom = () => {
    loadVendorOptions(vendorInputValue, vendorCurrentPage);
  };

  const handleVendorChange = (selectedOption) => {
    setExpense({ ...expense, vendor: selectedOption });
  };

  const loadContractOptions = async (inputValue) => {
    try {
      const searchTerm = inputValue === "" ? "%" : inputValue;
      const response = await axios.get(API + `contracts/contractsactive/filter/?id=${searchTerm}`, {
        headers: authHeader(),
      });
      const data = response.data.data || response.data.results || response.data;
      return Array.isArray(data) ? data : [];
    } catch (error) {
      console.error("Error loading contracts:", error);
      return [];
    }
  };


  const fetchFeeTypes = async () => {
    try {
      const res = await axios.get(API + "expenses/fee-types/", {
        headers: authHeader(),
      });
      setFeeTypeOptions(res.data);
    } catch (err) {
      console.error("Error loading fee types", err);
    }
  };


  const fetchAssetsForContract = async (contractId, rowIndex) => {
    if (!contractId) return;

    try {
      const response = await axios.get(API + `contracts/asset-view/${contractId}/`, {
        headers: authHeader(),
      });

      let assetsData = [];
      if (Array.isArray(response.data)) {
        assetsData = response.data;
      } else if (response.data.results && Array.isArray(response.data.results)) {
        assetsData = response.data.results;
      } else if (response.data.data && Array.isArray(response.data.data)) {
        assetsData = response.data.data;
      }

      setAllocations(prevAllocations =>
        prevAllocations.map((row, index) =>
          index === rowIndex ? { ...row, assetOptions: assetsData } : row
        )
      );

    } catch (error) {
      console.error("Error fetching assets:", error);
    }
  };

  const handleGridChange = (index, field, value) => {
    if (field !== 'contract' && field !== 'asset' && field !== 'customer') {
      setAllocations(prev => prev.map((row, i) =>
        i === index ? { ...row, [field]: value } : row
      ));
      return;
    }

    if (field === 'contract') {
      const selectedContract = value;

      setAllocations(prev => prev.map((row, i) => {
        if (i !== index) return row;

        if (selectedContract) {
          fetchAssetsForContract(selectedContract.id, index);

          let customerName = "";
          if (selectedContract.customer_name) {
            customerName = selectedContract.customer_name;
          } else if (selectedContract.party && typeof selectedContract.party === 'object') {
            customerName = selectedContract.party.customer_name || selectedContract.party.party_name || "";
          } else if (selectedContract.party_name) {
            customerName = selectedContract.party_name;
          }

          const customerObj = selectedContract.party
            ? {
              label: selectedContract.customer_name,
              value: selectedContract.party   // ✅ using party (customer ID)
            }
            : null;

          const custOptions = customerObj ? [customerObj] : [];

          return {
            ...row,
            contract: selectedContract,
            customer: customerObj,        // auto-selected
            customerOptions: custOptions,
            asset: null,
            assetOptions: []
          };

        }
        return { ...row, contract: null, customer: null, customerOptions: [], asset: null, assetOptions: [] };
      }));
    }

    if (field === 'asset') {
      setAllocations(prev => prev.map((row, i) =>
        i === index ? { ...row, asset: value } : row
      ));
    }

    if (field === 'customer') {
      setAllocations(prev => prev.map((row, i) =>
        i === index ? { ...row, customer: value } : row
      ));
    }
  };

  const addNewRow = () => {
    setAllocations([...allocations, { id: allocations.length + 1, contract: null, asset: null, customer: null, amount: "", feeType: "", assetOptions: [], customerOptions: [] }]);
  };

  const deleteRow = (index) => {
    setAllocations(prev => prev.filter((_, i) => i !== index));
  };

  const totalAllocated = allocations.reduce((sum, row) => sum + (parseFloat(row.amount) || 0), 0);

  const getVendorName = () => {
    return expense.vendor ? expense.vendor.customer_name : "";
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "payto") {
      setExpense({
        ...expense,
        payto: value,
        vendor: null,
        payee_name: "",
      });
      return;
    }

    setExpense({
      ...expense,
      [name]: value,
    });
  };

  const fetchSubCompanies = async () => {
    try {
      const res = await axios.get(API + "company/subcompanies/", {
        headers: authHeader(),
      });

      const data = res.data.data || res.data;

      if (Array.isArray(data)) {
        setSubcompanyOptions(data);

        // 🔹 Find default company
        const defaultCompany = data.find(c => c.default === true || c.is_default === true);

        if (defaultCompany) {
          setSubcompany(defaultCompany.id);
        }
      }

    } catch (err) {
      console.error("Error loading subcompanies", err);
    }
  };

  const fetchLineOfBusiness = async () => {
    try {
      const res = await axios.get(API + "company/lobs/", {
        headers: authHeader(),
      });

      const data = res.data.data || res.data;

      if (Array.isArray(data)) {
        setLineOfBusinessOptions(data);

        // 🔹 Find default LOB
        const defaultLob = data.find(lob => lob.default === true || lob.is_default === true);

        if (defaultLob) {
          setLineOfBusiness(defaultLob.id);
        }
      }
    } catch (err) {
      console.error("Error loading LOB", err);
    }
  };



  const handleFileChange = (e) => {
    setExpense({ ...expense, attachment: e.target.files[0] });
  };



  useEffect(() => {
    fetchExpenseCategories();
    fetchSubCompanies();
    fetchLineOfBusiness();
    fetchFeeTypes();
  }, []);

  const fetchExpenseCategories = async () => {
    try {
      setCategoryLoading(true);
      const res = await axios.get(API + "expenses/categories/", {
        headers: authHeader(),
      });

      const data = res.data.data || res.data;

      if (Array.isArray(data)) {
        setCategoryOptions(data);
      }

      setCategoryLoading(false);
    } catch (error) {
      console.error("Error loading expense categories:", error);
      setCategoryLoading(false);
    }
  };


  const handleSave = async (event) => {
    if (event) event.preventDefault();

    // =========================
    // Required Field Validation
    // =========================

    if (!subcompany) {
      toast.error("Company is required");
      return;
    }

    if (!expense.payto) {
      toast.error("Pay To is required");
      return;
    }

    if (expense.payto === "Vendor" && !expense.vendor) {
      toast.error("Vendor is required");
      return;
    }

    if (expense.payto === "Employee" && !expense.employee_name) {
      toast.error("Employee Name is required");
      return;
    }

    if (!expense.date) {
      toast.error("Expense Date is required");
      return;
    }

    if (!expense.amount || parseFloat(expense.amount) <= 0) {
      toast.error("Amount must be greater than 0");
      return;
    }

    if (!expense.category) {
      toast.error("Category is required");
      return;
    }

    // Check if user actually entered any item data
    const hasAnyItemData = allocations.some(row =>
      row.contract || row.asset || row.customer || row.amount || row.feeType
    );

    if (totalAllocated > parseFloat(expense.amount || 0)) {
      toast.error("Allocated amount cannot exceed Expense Amount");
      return;
    }


    // Validate only if items exist
    if (hasAnyItemData) {
      for (let i = 0; i < allocations.length; i++) {
        const row = allocations[i];

        // Skip fully empty rows
        if (!row.contract && !row.asset && !row.customer && !row.amount && !row.feeType) {
          continue;
        }

        if (!row.amount) {
          toast.error(`Row ${i + 1}: Amount is required`);
          return;
        }
        if (!row.feeType) {
          toast.error(`Row ${i + 1}: Fee Type is required`);
          return;
        }
      }
    }

    // Build allocations payload only if items exist
    const payloadAllocations = hasAnyItemData
      ? allocations
        .filter(row => row.contract || row.asset || row.customer || row.amount || row.feeType)
        .map(({ assetOptions, customerOptions, ...rest }) => ({
          contract: rest.contract?.id || null,
          asset: rest.asset?.id || null,
          customer: rest.customer?.value || null,
          fee_type: rest.feeType,
          amount: rest.amount
        }))
      : [];

    const payload = {
      ...expense,
      vendor: expense.vendor ? expense.vendor.id : null,
      employee_name: expense.employee_name || null,
      expense_category: expense.category,
      description: expense.description,
      amount: expense.amount,
      pay_to: expense.payto,
      expense_date: Helper.DatePicker(expense.date),
      reference: expense.reference,
      subcompany: subcompany || null,
      line_of_business: lineOfBusiness || null,
      allocations: payloadAllocations
    };

    console.log("Saving Payload:", payload);

    try {
      const res = await axios.post(API + "expenses/", payload, {
        headers: authHeader(),
      });

      const createdExpense = res.data;

      if (expense.attachments?.length) {
        for (let file of expense.attachments) {
          const formData = new FormData();
          formData.append("file", file);

          await axios.post(
            API + `expenses/${createdExpense.id}/attachments/`,
            formData,
            {
              headers: {
                ...authHeader(),
                "Content-Type": "multipart/form-data",
              },
            }
          );
        }
      }


      toast.success("Expense Saved Successfully!");

      setTimeout(() => navigate("/transactions"), 1500);
    } catch (error) {
      console.error("Save Error:", error);
      if (error.response) {
        console.error("Backend validation errors:", error.response.data);
        toast.error("Failed to save expense");
      } else {
        toast.error("Failed to save expense");
      }
    }
  };




  return (
    <div className="page-wrapper">
      <ToastContainer />
      <div className="content container-fluid">
        <div className="header pb-0 mb-3 pt-3">
          <div>
            <h5>{t("Expense Details")}</h5>
            <h6>
              <Link to="/transactions" className="tc">
                {t("Expenses")}
              </Link>{" "}
              / <span> {t("New Expense")} </span>
            </h6>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <div className="success"></div>

                <form>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-lg-12 col-form-label required">
                          {t("Company ")}
                          <Tooltip content={t("Subcompany_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="col-lg-12">
                          <select
                            className="form-select form-control"
                            value={subcompany}
                            onChange={(e) => setSubcompany(e.target.value)}
                          >
                            <option value="">Select Company</option>
                            {subcompanyOptions.map((sub) => (
                              <option key={sub.id} value={sub.id}>
                                {sub.sub_company_name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <label className="col-form-label">
                        {t("Line of Business")}
                        <Tooltip content={t("Lineofbusiness_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <select
                        className="form-select form-control"
                        value={lineOfBusiness}
                        onChange={(e) => setLineOfBusiness(e.target.value)}
                      >
                        <option value="">Select Line of Business</option>
                        {lineOfBusinessOptions.map((lob) => (
                          <option key={lob.id} value={lob.id}>
                            {lob.lob_name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-lg-12 col-form-label required">
                          {t("Pay To")}
                          <Tooltip content={t("The expense amount paid to")}><i className="fa fa-light fa-circle-info ms-1"></i></Tooltip>
                        </label>
                        <div className="col-lg-12">
                          <select name="payto" className="form-control" value={expense.payto} onChange={handleChange}>
                            <option value="">Select Type</option>
                            <option value="Vendor">Vendor</option>
                            <option value="Employee">Employee</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group row">

                        {/* Vendor */}
                        {expense.payto === "Vendor" && (
                          <>
                            <label className="col-lg-12 col-form-label required">
                              {t("Vendor")}
                            </label>
                            <div className="col-lg-12">
                              <Select
                                value={expense.vendor}
                                options={vendorOptions}
                                onChange={handleVendorChange}
                                onInputChange={handleVendorInputChange}
                                onMenuScrollToBottom={handleVendorMenuScrollToBottom}
                                isLoading={vendorIsLoading}
                                getOptionLabel={(option) => option.customer_name}
                                getOptionValue={(option) => option.id}
                                placeholder={t("Type % to search all")}
                                isClearable
                                filterOption={false}
                              />
                            </div>
                          </>
                        )}

                        {/* Employee */}
                        {expense.payto === "Employee" && (
                          <>
                            <label className="col-lg-12 col-form-label required">
                              {t("Employee Name")}
                            </label>
                            <div className="col-lg-12">
                              <input
                                type="text"
                                name="employee_name"
                                className="form-control"
                                value={expense.employee_name}
                                onChange={handleChange}
                                placeholder="Enter employee name"
                              />
                            </div>
                          </>
                        )}

                      </div>
                    </div>


                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-lg-12 col-form-label required">
                          {t("Expense Date")}
                          <Tooltip content={t("Date of Expense invoice made")}><i className="fa fa-light fa-circle-info ms-1"></i></Tooltip>
                        </label>
                        <div className="col-lg-12">
                          <DatePicker
                            className="form-control datepick"
                            selected={expense.date}
                            onChange={(e) => handleExpenseDate(e)}
                            name="date"
                            placeholderText={"mm/dd/yyyy"}
                            showYearDropdown
                            scrollableYearDropdown
                            showMonthDropdown
                            dropdownMode="select"
                          />
                        </div>

                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-lg-12 col-form-label required">
                          {t("Amount")}
                          <Tooltip content={t("Amount_Tooltip")}><i className="fa fa-light fa-circle-info ms-1"></i></Tooltip>
                        </label>
                        <div className="col-lg-12">
                          <input type="number" name="amount" className="form-control" value={expense.amount} onChange={handleChange} />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-lg-12 col-form-label required">
                          {t("Category")}
                          <Tooltip content={t("Category of Expense")}><i className="fa fa-light fa-circle-info ms-1"></i></Tooltip>
                        </label>
                        <div className="col-lg-12">
                          <Select
                            value={categoryOptions.find(c => c.category_name === expense.category) || null}
                            options={categoryOptions}
                            onChange={(selected) =>
                              setExpense({ ...expense, category: selected?.category_name || "" })
                            }
                            getOptionLabel={(option) => option.category_name}
                            getOptionValue={(option) => option.id}
                            placeholder={categoryLoading ? "Loading..." : "Select Category"}
                            isClearable
                            menuPlacement="auto"
                            styles={{
                              menuList: (base) => ({
                                ...base,
                                maxHeight: "240px",
                                overflowY: "auto",
                              }),
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-lg-12 col-form-label">
                          {t("Reference")}{" "}
                          <Tooltip content={t("Reference")}><i className="fa fa-light fa-circle-info"></i></Tooltip>
                        </label>
                        <div className="col-lg-12">
                          <input type="text" name="reference" className="form-control" value={expense.reference} onChange={handleChange} />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-lg-12 col-form-label">
                          {t("Description")}{" "}
                          <Tooltip content={t("Description_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip>
                        </label>
                        <div className="col-lg-12">
                          <textarea name="description" className="form-control" rows="3" value={expense.description} onChange={handleChange} placeholder="Enter expense details here..."></textarea>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-lg-12 col-form-label">
                          {t("Attachments")}{" "}
                          <Tooltip content={t("Attachments")}><i className="fa fa-light fa-circle-info"></i></Tooltip>
                        </label>
                        <div className="col-lg-12">
                          <input
                            type="file" className="form-control"
                            onChange={(e) =>
                              setExpense({
                                ...expense,
                                attachments: e.target.files
                              })
                            }
                          />
                        </div>
                      </div>
                    </div>

                  </div>
                </form>



                <div>

                  <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto', overflowX: 'hidden' }}>
                    <div className="row pt-3">
                      <div className="col-xl-6"><label className="col-form-label">{t("Reimbursement Details")}</label></div>
                      <div className="col-xl-6">
                        <div className="text-right">
                          <button type="button" className="btn btn-outline-success" onClick={addNewRow}>+ {t("ADD")}</button>
                        </div>
                      </div>
                    </div>

                    <table className="table table-nowrap mb-0">
                      <thead style={{ color: 'black' }}>
                        <tr>
                          <th className="col-form-label" style={{ minWidth: "200px", color: 'black' }}>
                            {t("Contract")}
                            <Tooltip content={t("Contract Number")}>
                              <i className="fa fa-light fa-circle-info ms-1"></i>
                            </Tooltip>
                          </th>
                          <th className="col-form-label" style={{ minWidth: "200px", color: 'black' }}>
                            {t("Asset")}
                            <Tooltip content={t("Asset Name")}>
                              <i className="fa fa-light fa-circle-info ms-1"></i>
                            </Tooltip>
                          </th>
                          <th className="col-form-label" style={{ minWidth: "200px", color: 'black' }}>
                            {t("Customer")}
                            <Tooltip content={t("Customer Name")}>
                              <i className="fa fa-light fa-circle-info ms-1"></i>
                            </Tooltip>
                          </th>
                          <th className="col-form-label" style={{ minWidth: "150px", color: 'black' }}>
                            {t("Amount")}
                            <Tooltip content={t("Allocated Amount")}>
                              <i className="fa fa-light fa-circle-info ms-1"></i>
                            </Tooltip>
                          </th>
                          <th className="col-form-label" style={{ minWidth: "150px", color: 'black' }}>
                            {t("Fee Type")}
                            <Tooltip content={t("Type of Fee")}>
                              <i className="fa fa-light fa-circle-info ms-1"></i>
                            </Tooltip>
                          </th>
                          <th className="col-form-label" style={{ width: "50px" }}></th>
                        </tr>
                      </thead>
                      <tbody>
                        {allocations.map((row, index) => (
                          <tr key={index}>
                            <td>
                              <AsyncSelect
                                cacheOptions
                                defaultOptions
                                value={row.contract}
                                loadOptions={loadContractOptions}
                                onChange={(selected) => handleGridChange(index, 'contract', selected)}
                                getOptionLabel={(option) => option.contract_number}
                                getOptionValue={(option) => option.id}
                                placeholder={t("Type % to search all")}
                                isClearable
                              />
                            </td>
                            <td>
                              <Select
                                value={row.asset}
                                options={row.assetOptions}
                                onChange={(selected) => handleGridChange(index, 'asset', selected)}
                                isDisabled={!row.contract}
                                getOptionLabel={(option) => option.asset_desc || option.asset_number || `Asset ID: ${option.id}`}
                                getOptionValue={(option) => option.id}
                                placeholder={t("Select Asset")}
                                isClearable
                                noOptionsMessage={() => "No assets found"}
                              />
                            </td>
                            <td>
                              <Select
                                value={row.customer}
                                options={row.customerOptions}
                                onChange={(selected) => handleGridChange(index, 'customer', selected)}
                                isDisabled={!row.contract}
                                placeholder={t("Select Customer")}
                                isClearable
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                className="form-control text-end"
                                value={row.amount}
                                disabled={!row.contract}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  handleGridChange(index, 'amount', value);

                                  const newTotal = allocations.reduce((sum, r, i) => {
                                    if (i === index) return sum + (parseFloat(value) || 0);
                                    return sum + (parseFloat(r.amount) || 0);
                                  }, 0);

                                  if (parseFloat(expense.amount || 0) && newTotal > parseFloat(expense.amount)) {
                                    setAllocationError("Allocated amount cannot exceed Expense Amount");
                                  } else {
                                    setAllocationError("");
                                  }
                                }}
                              />
                              {allocationError && (
                                <div className="text-danger" style={{ fontSize: '12px' }}>{allocationError}</div>
                              )}
                            </td>
                            <td>
                              <select
                                className="form-control"
                                value={row.feeType}
                                disabled={!row.contract}
                                onChange={(e) => handleGridChange(index, 'feeType', e.target.value)}
                              >
                                <option value="">{t("Select Fee Type")}</option>

                                {feeTypeOptions.map(ft => (
                                  <option key={ft.value} value={ft.value}>
                                    {ft.label}
                                  </option>
                                ))}
                              </select>
                            </td>
                            <td>
                              <button className="btn btn-outline-danger" onClick={() => deleteRow(index)}>x</button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colSpan="3" className="border-0"></td>
                          <td className="fw-bold text-end" style={{ backgroundColor: '#e9ecef' }}>{totalAllocated.toFixed(2)}</td>
                          <td className="border-0"></td>
                          <td className="border-0"></td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>

                  <div className="d-flex align-items-start py-3">
                    <button type="button" className="btn-cancel-invoice border-0 btn btn-secondary btn-gradient-primary btn-md" onClick={() => navigate("/transactions")}>{t("Cancel")}</button>
                    &nbsp;&nbsp;
                    <button type="button" className="btn-continue border-0 btn btn-primary btn-gradient-primary btn-md" onClick={handleSave}>{t("Save")}</button>
                    {!isApprovalDisabled && (
                    <div style={{ marginLeft: "15px", fontSize: "13px", color: "#6c757d" }}>
                      This transaction needs to be submitted for approval.
                      <br />
                      Please navigate to the view screen to submit for approval.
                    </div>
                    )}
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}